import React, { FC, useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { SCUIContent } from '../../../atomic/organisms';
import CopyToClipboardButton from '../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import {
    SCUIReturnDetailModalApprove,
    SCUIReturnDetailProductTable,
    SCUIReturnRejectDrawerContent,
} from '../ReturnDetail/components';
import { SCUIBreadCrumb, SCUIGeneralDrawer, SCUITextFieldWithButton } from '../../../atomic/molecules';
import {
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    Divider,
    Drawer,
    FormControlLabel,
    Grid,
    Paper,
    Tooltip,
    Typography,
    Chip,
} from '@mui/material';
import {
    CompleteAndConfirmQuery,
    CustomerQuery,
    ReturnQuery,
    RefundRestQuery,
    CacheQuery,
} from '../../../services/query';
import { SCUIButton, SCUILoadingLinear } from '../../../atomic/atoms';
import { getParamsReturnDetailByReturnID, findProductsByScannedBarcode, isProductBarcodeMatch } from './ReturnDetail.helper';
import { ReturnCommand } from '../../../services/command';
import { enumReturnStatus } from '../../../types/enums/status';
import { useHistory, Link, Prompt } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../ReturnDetail/ReturnDetail.scss';
import Helper from '../../../utils/helper';
import ReportIcon from '@mui/icons-material/Report';
import CloseIcon from '@mui/icons-material/Close';
import { RefundPrepareSellerReturnShipment } from '../RefundV2/components';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReturnStatusHistoryDrawer from './components/ReturnStatusHistoryDrawer/ReturnStatusHistoryDrawer';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import ReturnStatusUpdate from './components/ReturnStatusUpdate/ReturnStatusUpdate';
import { useSelector } from 'react-redux';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

export const ReturnDetailV2: FC<any> = (props: any) => {
    //#region variables
    const query = new URLSearchParams(useLocation().search);
    const [disabledCancelButton, setDisabledCancelButton] = useState(false);
    const [isMarketPlaceReturn, setIsMarketPlaceReturn] = useState(false);
    const [promptControl, setPromptControl] = useState(false);
    const [disabledResetButton, setDisabledResetButton] = useState(false);
    const [disabledCompleteAndConfirmButton, setDisabledCompleteAndConfirmButton] = useState(false);
    const [visibleTaslakButton, setVisibleTaslakButton] = useState(false);
    const [productCountIsBigger, setProductCountIsBigger] = useState(false);
    const [barcodeNotFound, setBarcodeNotFound] = useState(false);
    const [selectedQrCodes, setSelectedQrCodes] = useState<any>({});
    const onDrawerRejectedOpen = () => setDrawerRejectedOpen(true);
    const onDrawerRejectedClose = () => setDrawerRejectedOpen(false);
    const onMPShippingOpen = () => setMpDrawerRejectedOpen(true);
    const onMPShippingClose = () => setMpDrawerRejectedOpen(false);
    const [drawerRejectedOpen, setDrawerRejectedOpen] = useState(false);
    const [mpShippingDrawerOpen, setMpDrawerRejectedOpen] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const idfromUrl = query.get('ReturnId');
    const customerfromUrl = query.get('customerId');
    const [loading, setLoading] = useState(true);
    const [reloadShowMessage, setReloadShowMessage] = useState(true);
    const history = useHistory();
    const { t } = useTranslation();
    const returnId = props.location.state?.returnId ? props.location.state?.returnId : idfromUrl;
    const customerId = props.location.state?.customerId ? props.location.state?.customerId : customerfromUrl;
    const [returnDatas, setReturnData] = React.useState<any>();
    const [returnDatasProducts, setReturnDatasProducts] = React.useState<any>();
    const [returnedProductItemProcesses, setreturnedProductItemProcesses] = useState<any>([]);
    const [visibleCreateAndConfirmButton, setVisibleCreateAndConfirmButton] = useState(false);
    const [selectableProductForComplete, setSelectableProductForComplete] = useState(false);
    const [isBlackListCustomer, setIsBlackListCustomer] = useState(false);
    const [returnMessage, setReturnMessage] = useState('');
    const [returnDataInital, setReturnDataInitial] = React.useState<any>();
    const [selectedProductBarcode, setSelectedProductBarcode] = useState('');
    const [selectedProduct, setSelectedProduct] = useState<any>();
    const [returnReason, setReturnReason] = React.useState<any>();
    const [returnRejectedReason, setReturnRejectedReason] = React.useState<any>();
    const [scannedBarcodeForModal, setScannedBarcodeForModal] = useState<any>('');
    const [draftHistoryData, setDraftHistoryData] = useState<any>([]);
    const onModalOpen = () => setModalOpen(true);
    const onModalClose = () => setModalOpen(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [refundId, setRefundId] = React.useState<any>();
    const [cachedRequestData, setCachedRequestData] = useState<any>();
    const [rejectedShippingIDs, setRejectedShippingIDs] = React.useState<any>();
    const [selectedRejectedShippingID, setSelectedsetRejectedShippingID] = React.useState<any>();
    const [refresh, setRefresh] = useState(false);
    const [orderDate, setOrderDate] = useState<any>();
    const [disableAprroveProduct, setDisableAprroveProduct] = useState<any>();
    const [isMpRejectReturn, setIsMpRejectReturn] = useState(false);
    const [source, setSource] = useState<any>(null);
    const [isRejectedReturn, setIsRejectedReturn] = React.useState(false);
    const [changeStatusModelVisible, setChangeStatusModelVisible] = useState(false);
    const [isLostPackage, setIsLostPackage] = useState(false);
    const [draftPerson, setDraftPerson] = React.useState<any>();
    const [draftHistoryModalOpen, setDraftHistoryModalOpen] = useState(false);
    const darkModeStore: any = useSelector((state: any) => state?.darkMode);
    const other_link: any = import.meta.env.VITE_APPURL!;
    const chipStyleBackground = {
        padding: '0.5rem 1rem',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '0.5rem',
        cursor: 'pointer',
        marginTop: '0.70rem',
        minWidth: '70px',
        minHeight: '30px',
    };
    const returnStatusList = [1, 2, 3, 5, 6, 7, 8, 9];
    const [shippingCompanyName, setShippingCompanyName] = useState('');
    const [trackingUrl, setTrackingUrl] = useState('');
    const [trackingCode, setTrackingCode] = useState('');
    const prevReturnId = useRef();
    const prevRmaCode = useRef();
    const completeAndConfirmButtonRef = useRef<HTMLSpanElement | null>(null);
    const [expandedBarcodesRows, setExpandedBarcodesRows] = useState<{ [key: number]: boolean }>({});
    const toggleBarcodeRowExpansion = (index: number) => {
        setExpandedBarcodesRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    const [returnRejectShipmentVisible, setReturnRejectShipmentVisible] = useState<boolean>();
    const [showResetButtonFromRule, setShowResetButtonFromRule] = useState(false);
    const lostPackageStatus = 13;

    const GetCustomerRiskStatusByCustomerId = async () => {
        try {
            if (customerId) {
                CustomerQuery.GetCustomerRiskStatusByCustomerId(customerId)
                    .then((res: any) => {
                        if (res.data) {
                            if (res.data.isCusromerRisky) {
                                setIsBlackListCustomer(res.data.isCusromerRisky);
                            }
                            setSource(res.data.source);
                        }
                    })
                    .catch((error: any) => {
                        console.log('Hata :>> ', error);
                    });
            }
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    const selectedLanguage = 'tr-TR';

    useEffect(() => {
        if (isMarketPlaceReturn) {
            CacheQuery.GetUSerClaims().then((res: any) => {
                setDisableAprroveProduct(
                    res.includes('backoffice_cmMpRejectReturn') || res.includes('backoffice_mpReturnApprover')
                );
                setIsMpRejectReturn(res.includes('backoffice_cmMpRejectReturn'));
            });
        }
    }, [isMarketPlaceReturn]);

    useEffect(() => {
        if (!visibleCreateAndConfirmButton || !returnDatas?.isReturnable || disabledCompleteAndConfirmButton) {
            return;
        }
        const frameId = window.requestAnimationFrame(() => {
            const buttonEl = completeAndConfirmButtonRef.current?.querySelector<HTMLButtonElement>('button');
            buttonEl?.focus();
        });
        return () => window.cancelAnimationFrame(frameId);
    }, [visibleCreateAndConfirmButton, returnDatas?.isReturnable, disabledCompleteAndConfirmButton]);
    useEffect(() => {
        GetReturnReason();
    }, [returnDatas]);
    const GetReturnReason = () => {
        if (returnDatas) {
            let param = {
                shippingHasLostPackage: returnDatas.isLostPackage,
            };
            ReturnQuery.GetReturnReason(param).then((res: any) => {
                setReturnReason(res.data);
            });
        }
    };
    const GetDraftHistory = () => {
        let params = {
            returnId: returnDatas?.returnId,
        };
        ReturnQuery.GetDraftHistory(params)
            .then((res: any) => {
                if (res) {
                    setDraftHistoryData(res);
                } else {
                    setDraftHistoryData([]);
                    Swal.fire(t('general.noDataFound'));
                }
            })
            .catch((error: any) => {
                console.error(t('general.error'), error);
                setDraftHistoryData([]);
            });
    };
    const draftHistory = () => {
        setDraftHistoryModalOpen(true);
        GetDraftHistory();
    };
    const handleCloseDraftHistory = () => {
        setDraftHistoryModalOpen(false);
    };
    const GetReturnRejectedReason = () => {
        ReturnQuery.GetReturnRejectedReason().then((res: any) => {
            setReturnRejectedReason(res.data);
        });
    };
    const GetReturnDetailByReturnId = () => {
        ReturnQuery.GetReturnDetailByReturnId(getParamsReturnDetailByReturnID(returnId, customerId))
            .then((res: any) => {
                if (res?.data) {
                    if (res?.data?.productDetailModels?.every((product: any) => product.reason == lostPackageStatus)) {
                        window.location.href =
                            '/lost-cargo-return-detail-page?returnId=' + returnId + '&customerId=' + customerId;
                    }
                    if (res?.data?.orderDate) {
                        setOrderDate(res?.data?.orderDate);
                    }
                    setReturnData(res?.data);
                    setReturnDataInitial(res?.data);
                    setIsMarketPlaceReturn(res?.data?.isMarketPlaceReturn);
                    setPromptControl(res?.data?.boStatus === 1);
                    setIsLostPackage(res?.data?.isLostPackage);
                    const rejectedProducts = res?.data?.productDetailModels?.filter(
                        (product: any) => product.rejectedQuantity > 0
                    );
                    setRejectedShippingIDs(
                        Array.from(new Set(rejectedProducts.map((product: any) => product.shippingListId)))
                    ); // reddedilen ürünleri shippinglistId bazında gruplandırıp gösteriyoruz
                    if (
                        !(
                            res.data.boStatus === 0 ||
                            res.data.boStatus === 1 ||
                            res.data.boStatus === 2 ||
                            res.data.boStatus === 4
                        )
                    ) {
                        if (rejectedProducts.length > 0) {
                            setIsRejectedReturn(true);
                        }
                    }
                } else Swal.fire(t('general.noDataFound'), '', 'error');
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const CancelReturn = async () => {
        setLoading(true);
        setDisabledCancelButton(true);
        let params: any = {};
        params.returnId = returnDatas.returnId;
        params.customerID = customerId;
        params.storeCode = Helper.getStoreCode();
        params.isMarketPlaceReturn = isMarketPlaceReturn;

        try {
            let Info = await ReturnCommand.CancelReturn(params);
            if (Info && Info.result) {
                DeleteCompleteAndConfirmQueryRequestData();
                setVisibleTaslakButton(false);
                setDisabledCancelButton(false);
                Swal.fire(t('general.requestCancelled'), ' ', 'success');
                setRefresh((prevLoading) => !prevLoading);
            } else Swal.fire('Hata', ' ', 'error');
        } finally {
            setLoading(false);
        }
    };
    const GetRefunDofReturn = () => {
        RefundRestQuery.GetRefundOfReturn({
            returnId: returnId,
            orderDate: orderDate ? orderDate : null,
        }).then((res: any) => {
            if (res) {
                setRefundId(res.refundId);
            }
        });
    };
    const GetCompleteAndConfirmQueryRequestData = () => {
        CompleteAndConfirmQuery.GetRequestData({ ReturnId: returnId }).then((res: any) => {
            if (res) {
                setreturnedProductItemProcesses(res.completeAndConfirmRequestData);
            }
            if (res) {
                setVisibleTaslakButton(true);
            }
            if (res) {
                setCachedRequestData(res.completeAndConfirmRequestData);
            }
            if (res) {
                setDraftPerson(res.userName);
            }
        });
    };
    const UpdateCompleteAndConfirmQueryRequestData = () => {
        if (cachedRequestData) {
            CompleteAndConfirmQuery.UpdateRequestData({
                ReturnId: returnId,
                CompleteAndConfirmRequestData: returnedProductItemProcesses,
            }).then(() => {
                Swal.fire(t('general.draftUpdated'), ' ', 'success');
                setReloadShowMessage(false);
                window.location.reload();
            });
        }
    };

    const AddCompleteAndConfirmQueryRequestData = () => {
        CompleteAndConfirmQuery.AddRequestData({
            ReturnId: returnId,
            CompleteAndConfirmRequestData: returnedProductItemProcesses,
        }).then(() => {
            Swal.fire(t('general.draftSaved'), ' ', 'success');
            setReloadShowMessage(false);
            window.location.reload();
        });
    };
    const DeleteCompleteAndConfirmQueryRequestData = () => {
        setPromptControl(false);
        if (cachedRequestData) {
            CompleteAndConfirmQuery.DeleteRequestData(returnId).then(() => {});
        }
    };

    const ResetReturn = async () => {
        setLoading(true);
        setDisabledResetButton(true);
        let params: any = {};
        params.returnId = returnDatas.returnId;
        params.customerID = customerId;
        try {
            DeleteCompleteAndConfirmQueryRequestData();
            setVisibleTaslakButton(false);
            let res = await ReturnCommand.ResetReturn(params);
            setReloadShowMessage(false);
            window.location.reload();
            if (res === 1) {
                setDisabledResetButton(false);
                Swal.fire(t('general.operationRevertedSuccessfully'), ' ', 'success');
                setRefresh((prevLoading) => !prevLoading);
            } else Swal.fire('', ' ', 'error');
        } finally {
            setLoading(false);
        }
    };

    const checkQRCodeUsage = (rmaCode: string): boolean => {
        if (rmaCode) {
            const qrCodeData = localStorage.getItem('rmaCodeWithQRCode');
            if (qrCodeData) {
                const parsedData = JSON.parse(qrCodeData);
                if (
                    parsedData &&
                    parsedData.rmaCodeWithoutPrefix === String(rmaCode) &&
                    typeof parsedData.IsQRCodeUse === 'boolean'
                ) {
                    return parsedData.IsQRCodeUse;
                }
            }
        }
        return false;
    };

    const getSelectedQrCodes = (products: any[]): any[] | undefined => {
        const selectedQrCodes: any[] = [];
        for (const product of products) {
            if (
                product.qrCodeListModel &&
                Array.isArray(product.qrCodeListModel) &&
                product.qrCodeListModel.length > 0
            ) {
                const qrCodeModels = product.qrCodeListModel.map((qrCode: any) => {
                    if (typeof qrCode === 'string') {
                        return { qrCode };
                    }
                    return qrCode;
                });
                selectedQrCodes.push(...qrCodeModels);
            }
        }
        return selectedQrCodes.length > 0 ? selectedQrCodes : undefined;
    };

    const CompleteAndConfirmReturn = async () => {
        setDisabledCompleteAndConfirmButton(true);

        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                setLoading(true);
                setDisabledCancelButton(true);
                setDisabledResetButton(true);

                let params: any = {};
                params.orderId = returnDatas.orderId;
                params.returnId = returnDatas.returnId;
                params.customerID = customerId;
                params.storeCode = Helper.getStoreCode();
                params.isMarketPlaceReturn = isMarketPlaceReturn;
                params.isLostPackage = isLostPackage;
                params.returnedProductItemProcesses = returnedProductItemProcesses;
                params.isQRCodeUse = checkQRCodeUsage(returnDatas?.rmaCode);
                params.selectedQrCodes = getSelectedQrCodes(returnedProductItemProcesses);

                try {
                    setVisibleTaslakButton(false);
                    DeleteCompleteAndConfirmQueryRequestData();
                    let res: any = await ReturnCommand.CompleteAndConfirmReturn(params);
                    const isRejectedProduct: boolean = returnedProductItemProcesses.some(
                        (product: any) => product.rejectedQuantity > 0
                    );
                    Swal.fire({
                        text: res.returnedProductProcess?.returnMessages,
                        icon: res.returnedProductProcess?.result ? 'success' : 'error',
                        timer: res.returnedProductProcess?.result ? 1500 : undefined,
                        timerProgressBar: res.returnedProductProcess?.result,
                        showConfirmButton: !res.returnedProductProcess?.result,
                        confirmButtonText: t('general.ok'),
                    });

                    if (!res.returnedProductProcess?.result) {
                        setDisabledCancelButton(false);
                        setDisabledResetButton(false);
                        setDisabledCompleteAndConfirmButton(false);
                    }
                    if (isRejectedProduct) {
                        if (res.returnedProductProcess) {
                            setRefresh((prevLoading) => !prevLoading);
                            GetRefunDofReturn();
                        }
                    } else {
                        ReturnQuery.GetReturnDetailByReturnId(
                            getParamsReturnDetailByReturnID(returnId, customerId)
                        ).then((response: any) => {
                            if (response.data.boStatus !== 2 && response.data.boStatus !== 9) {
                                if (res.returnedProductProcess?.result) {
                                    history.push('/ReturnList');
                                }
                            } else {
                                window.location.reload();
                            }
                        });
                    }
                } finally {
                    setLoading(false);
                }
            }
        });
    };
    const GetReturnRejectShipmentVisibleRule = () => {
        ReturnQuery.GetReturnRejectShipmentVisibleRule()
            .then((res: any) => {
                if (res) {
                    setReturnRejectShipmentVisible(res);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const GetShowResetButtonRule = () => {
        ReturnQuery.GetShowResetButtonRule()
            .then((res: any) => {
                if (res) {
                    setShowResetButtonFromRule(res);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    useEffect(() => {
        if (returnId) {
            GetReturnDetailByReturnId();
        }
    }, [returnId, customerId, refresh]);
    useEffect(() => {
        if (returnDatas && returnDatas.returnMessages) {
            setReturnMessage(Helper.sanitizeHTML(returnDatas.returnMessages));
        }
    }, [returnDatas]);
    useEffect(() => {
        if (cachedRequestData && returnDatas && returnDatas.isReturnable) {
            const updatedProducts = returnDatas.productDetailModels.map((product: any) => {
                const match = cachedRequestData.find(
                    (item: any) =>
                        isProductBarcodeMatch(product, item.barcode) &&
                        item.returnItemId === product.returnItemId
                );

                return match
                    ? {
                          ...product,
                          ...{
                              quantity: match.quantity,
                              restockQuantity: match.restockQuantity,
                              nonRestockQuantity: match.nonRestockQuantity,
                              rejectedQuantity: match.rejectedQuantity,
                              operatorReturnReasonId: match.operatorReturnReasonId,
                              status: match.statusId,
                              returnItemId: match.returnItemId,
                              productId: match.productId,
                              rejectedReason: match.rejectedReason,
                          },
                      }
                    : product;
            });
            if (JSON.stringify(returnDatas.productDetailModels) !== JSON.stringify(updatedProducts)) {
                setreturnedProductItemProcesses(
                    // eski boda okutulan kayıtların görünmesi için
                    updatedProducts.map((item: any) => {
                        return {
                            returnItemId: item.returnItemId,
                            productId: item.productId,
                            barcode: item.barcode,
                            quantity: item.piece,
                            restockQuantity: item.restockQuantity,
                            nonRestockQuantity: item.nonRestockQuantity,
                            rejectedQuantity: item.rejectedQuantity,
                            operatorReturnReasonId: item.operatorReturnReasonId,
                            rejectedReason: item.rejectedReason,
                            statusId: item.status,
                            shippingListId: item.shippingListId,
                        };
                    })
                );
            }
            setReturnDatasProducts(updatedProducts);
            setVisibleCreateAndConfirmButton(
                //completeandconfirm buton görünürlük
                returnDatas.isReturnable &&
                    updatedProducts.length === returnedProductItemProcesses.length &&
                    updatedProducts.every(
                        (item: any) =>
                            item.restockQuantity + item.rejectedQuantity + item.nonRestockQuantity === item.quantity
                    )
            );
        } else {
            if (returnDatas) {
                setReturnDatasProducts(returnDatas.productDetailModels);
            }
        }
    }, [cachedRequestData, returnDatas]);
    useEffect(() => {
        GetReturnRejectedReason();
        GetCustomerRiskStatusByCustomerId();
        GetCompleteAndConfirmQueryRequestData();
        GetReturnRejectShipmentVisibleRule();
        GetShowResetButtonRule();
    }, []);

    useEffect(() => {
        GetCompleteAndConfirmQueryRequestData();
    }, [returnDatas]);
    useEffect(() => {
        if (returnDatas && (returnDatas.boStatus === 3 || returnDatas.boStatus === 2)) {
            GetRefunDofReturn(); //tamamlandı statüsünde refund bilgisi çek
        }
    }, [returnDatas]);
    //#endregion
    //#region filter
    const barcodeSearch = (): void => {
        setBarcodeNotFound(false);
        setProductCountIsBigger(false);
        if (selectedProductBarcode.trim().length === 0) {
            setReturnData(returnDataInital);
            return;
        }

        const selectedProduct =
            returnDatas &&
            returnDatasProducts &&
            findProductsByScannedBarcode(returnDatasProducts, returnedProductItemProcesses, selectedProductBarcode);

        if (!selectedProduct) {
            setBarcodeNotFound(true);
        }
        if (selectedProduct && selectedProduct.length === 0) {
            setBarcodeNotFound(true);
        } else if (selectedProduct && selectedProduct.length > 0) {
            setScannedBarcodeForModal(selectedProductBarcode.trim());
            if (returnDatas.isReturnable) {
                onModalOpen();
            }
            setSelectedProduct(selectedProduct);
            if (!returnDatas.isReturnable) {
                setReturnData({
                    ...returnDataInital,
                    productDetailModels: selectedProduct,
                });
            }
            if (returnDatas.status === 0) {
                let req: any = {
                    storeCode: Helper.getStoreCode(),
                    returnId: Number(returnId),
                    status: 1,
                    customerId: Number(customerId),
                };
                ReturnCommand.UpdateReturnStatus(req).then((res: any) => {
                    if (res.result) {
                        setPromptControl(true);
                        setReturnData({
                            ...returnDatas,
                            boStatusDescription: t('general.processing'),
                            statusDescription: t('general.processing'),
                            boStatus: 1,
                            status: 1,
                            statusCode: 'Processing',
                        });
                    }
                });
            }
            setSelectedProductBarcode('');
        }
    };
    //#endregion
    const resetCompleteAndConfirmAll = () => {
        setReturnDatasProducts(
            returnDatasProducts.map((item: any) => {
                return { ...item, isSelectedProduct: false };
            })
        );
        setreturnedProductItemProcesses([]);
        setVisibleCreateAndConfirmButton(false);
    };

    const resetForSelectedProduct = (barcode: any) => {
        setReturnDatasProducts(
            returnDatasProducts.map((item: any) => {
                if (item.barcode === barcode || item.barcodeList?.includes(barcode)) {
                    return {
                        ...returnDataInital.productDetailModels.find((product: any) => product.barcode === item.barcode || product.barcodeList?.includes(item.barcode)),
                        restockQuantity: 0,
                        nonRestockQuantity: 0,
                        rejectedQuantity: 0,
                        operatorReturnReasonId: 0,
                        rejectedReasonDescription: '',
                        isSelectedProduct: false,
                    };
                } else {
                    return item;
                }
            })
        );
        setreturnedProductItemProcesses(
            returnedProductItemProcesses.filter((product: any) => 
                product.barcode !== barcode && 
                product.returnItemId !== returnDatasProducts.find((p: any) => p.barcode === barcode || p.barcodeList?.includes(barcode))?.returnItemId
            )
        );
        setVisibleCreateAndConfirmButton(false);
    };

    const CompletAndConfirmAll = () => {
        setReturnDatasProducts(
            returnDatasProducts.map((item: any) => {
                return {
                    ...item,
                    isSelectedProduct: true,
                    quantity: item.piece,
                    restockQuantity: item.restockQuantity === 0 ? item.piece : item.restockQuantity,
                    nonRestockQuantity: item.nonRestockQuantity,
                    rejectedQuantity: item.rejectedQuantity,
                    operatorReturnReasonId: item.operatorReturnReasonId,
                    rejectedReason: item.reason,
                    storeCode: Helper.getStoreCode(),
                    statusId: item.status,
                };
            })
        );
        setreturnedProductItemProcesses(
            returnDatas.productDetailModels.map((item: any) => {
                return {
                    returnItemId: item.returnItemId,
                    productId: item.productId,
                    barcode: item.barcode,
                    quantity: item.piece,
                    restockQuantity: item.restockQuantity === 0 ? item.piece : item.restockQuantity,
                    nonRestockQuantity: item.nonRestockQuantity,
                    rejectedQuantity: item.rejectedQuantity,
                    operatorReturnReasonId: item.operatorReturnReasonId,
                    rejectedReason: item.reason,
                    statusId: item.status,
                    shippingListId: item.shippingListId,
                };
            })
        );
        setVisibleCreateAndConfirmButton(true);
    };

    const formattedCreateConfirm = (returnProduct: any): void => {
        setVisibleTaslakButton(true);
        setProductCountIsBigger(false);
        const returnDatasProductList: any = returnDatasProducts.map((item: any) => {
            if (item.returnItemId === returnProduct.returnItemId) {
                const totalQuantity =
                    item.rejectedQuantity +
                    returnProduct.rejectedQuantity +
                    item.restockQuantity +
                    returnProduct.restockQuantity +
                    item.nonRestockQuantity +
                    returnProduct.nonRestockQuantity;
                    if (totalQuantity <= returnProduct.quantity) {
                    return {
                        ...item,
                        isSelectedProduct: true,
                        rejectedQuantity: item.rejectedQuantity + returnProduct.rejectedQuantity,
                        restockQuantity: item.restockQuantity + returnProduct.restockQuantity,
                        nonRestockQuantity: item.nonRestockQuantity + returnProduct.nonRestockQuantity,
                        operatorReturnReasonId: returnProduct.operatorReturnReasonId,
                        rejectedReason: returnProduct.rejectedReason,
                    };
                    } else {
                    setProductCountIsBigger(true);
                    return item;
                }
            } else {
                return item;
            }
        });

        setReturnDatasProducts(returnDatasProductList);
        let updatedReturnedProductItemProcesses = [...returnedProductItemProcesses];
        const isBarcodeMatch = updatedReturnedProductItemProcesses.some(
            (item) => item.returnItemId === returnProduct.returnItemId
        );

        if (!isBarcodeMatch) {
            updatedReturnedProductItemProcesses.push(returnProduct);
        } else {
            updatedReturnedProductItemProcesses = updatedReturnedProductItemProcesses.map((item) => {
                if (item.returnItemId === returnProduct.returnItemId) {
                    const totalQuantity =
                        item.rejectedQuantity +
                        returnProduct.rejectedQuantity +
                        item.restockQuantity +
                        returnProduct.restockQuantity +
                        item.nonRestockQuantity +
                        returnProduct.nonRestockQuantity;

                    if (totalQuantity <= returnProduct.quantity) {
                        return {
                            ...item,
                            rejectedQuantity: item.rejectedQuantity + returnProduct.rejectedQuantity,
                            restockQuantity: item.restockQuantity + returnProduct.restockQuantity,
                            nonRestockQuantity: item.nonRestockQuantity + returnProduct.nonRestockQuantity,
                            operatorReturnReasonId: returnProduct.operatorReturnReasonId,
                            rejectedReason: returnProduct.rejectedReason,
                            barcode: returnProduct.barcode,
                            qrCodeListModel: [
                                ...(item.qrCodeListModel || []),
                                ...(returnProduct.qrCodeListModel || []),
                            ],
                        };
                    } else {
                        return item;
                    }
                }
                return item;
            });
        }

        setreturnedProductItemProcesses(updatedReturnedProductItemProcesses);
        setVisibleCreateAndConfirmButton(
            //completeandconfirm buton görünürlük
            updatedReturnedProductItemProcesses.length === returnDatas.productDetailModels.length &&
                updatedReturnedProductItemProcesses.every(
                    (item: any) =>
                        item.restockQuantity + item.rejectedQuantity + item.nonRestockQuantity === item.quantity
                )
        );
    };

    const refund = () => {
        if (refundId) {
            window.open(other_link + '/RefundV2/?id=' + refundId, '_blank');
        }
    };
    const orderDetail = () => {
        window.open(other_link + '/orderDetail?OrderNumber=' + returnDatas.orderNumber, '_blank');
    };

    //#region sayfayenileme
    useEffect(() => {
        const handleKeyPress = (event: any) => {
            if (event.keyCode === 13 && !disabledCompleteAndConfirmButton && !modalOpen) {
                document.removeEventListener('keydown', handleKeyPress);

                CompleteAndConfirmReturn();
            }
        };

        if (visibleCreateAndConfirmButton) {
            document.addEventListener('keydown', handleKeyPress);
        } else {
            document.removeEventListener('keydown', handleKeyPress);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [visibleCreateAndConfirmButton, modalOpen, disabledCompleteAndConfirmButton]);

    useEffect(() => {
        //sayfa yenilerken işlem var mı kontrole
        const beforeUnloadHandler = function (event: any) {
            const confirmationMessage = t('general.leavePagePrompt');
            const userConfirmation = window.confirm(confirmationMessage);

            if (!userConfirmation) {
                event.preventDefault();
                event.returnValue = confirmationMessage;
            }
        };
        if (!Helper.isStoreEmployeeForFrontend()) {
            if (reloadShowMessage) {
                window.addEventListener('beforeunload', beforeUnloadHandler);
            }
        }

        return () => {
            if (Helper.isStoreEmployeeForFrontend()) {
                window.removeEventListener('beforeunload', beforeUnloadHandler);
            }
        };
    }, []);
    //#endregion
    const toggleDrawer = (open: any) => (event: any) => {
        if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
            return;
        }
        setIsDrawerOpen(open);
    };
    const handleOpenChangeStatusModal = () => {
        setChangeStatusModelVisible(true);
    };
    const handleCloseChangeStatusModal = () => {
        setChangeStatusModelVisible(false);
    };

    const checkStatusInList = (status: number) => {
        return returnStatusList.includes(status);
    };

    useEffect(() => {
        const fetchTrackingInfo = async () => {
            try {
                const res = await ReturnCommand.GetReturnTrackingInfo({
                    returnId: returnDatas?.returnId,
                    rmaCode: returnDatas?.rmaCode,
                });
                console.log(returnDatas, 'returndatas');
                if (res && res.trackingUrl !== '') {
                    setTrackingUrl(res.trackingUrl);
                    setShippingCompanyName(res.shippingCompanyName);
                }
                if (res && res.trackingCode !== '') {
                    setTrackingCode(res.trackingCode);
                }
            } catch (error) {
                console.error('Error fetching tracking URL:', error);
            }
        };

        if (returnDatas?.returnId !== prevReturnId.current || returnDatas?.rmaCode !== prevRmaCode.current) {
            fetchTrackingInfo();
            prevReturnId.current = returnDatas?.returnId;
            prevRmaCode.current = returnDatas?.rmaCode;
        }
    }, [returnDatas]);

    const handleLinkClick = () => {
        if (trackingUrl) {
            window.open(trackingUrl, '_blank', 'noopener,noreferrer');
        } else {
            Swal.fire(t('return.trackingUrlError'), '', 'error');
        }
    };

    return (
        <SCUIContent>
            <Dialog
                open={changeStatusModelVisible}
                onClose={handleCloseChangeStatusModal}
                slotProps={{
                    paper: {
                        sx: {
                            minWidth: '400px',
                            maxWidth: '80%',
                            height: 'auto',
                        },
                    },
                }}
            >
                <DialogContent>
                    <ReturnStatusUpdate
                        fromReturnStatusId={returnDatas?.boStatus}
                        returnId={returnDatas?.returnId}
                        customerId={customerId}
                        handleCloseChangeStatusModal={handleCloseChangeStatusModal}
                    />
                </DialogContent>
            </Dialog>
            <Drawer anchor="top" open={isDrawerOpen} onClose={toggleDrawer(false)}>
                <ReturnStatusHistoryDrawer returnId={returnDatas?.returnId} onClose={toggleDrawer(false)} />
            </Drawer>
            <Prompt when={promptControl} message={t('general.leavePagePrompt')} />
            <SCUILoadingLinear display={loading} />
            {selectedRejectedShippingID && (
                <SCUIGeneralDrawer
                    open={drawerRejectedOpen}
                    width={'400px'}
                    onClose={(_: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            onDrawerRejectedClose();
                        }
                    }}
                >
                    <SCUIReturnRejectDrawerContent
                        isMpRejectReturn={isMpRejectReturn}
                        onClose={onDrawerRejectedClose}
                        selectedRejectedShippingID={selectedRejectedShippingID}
                        returnId={returnId}
                        orderId={returnDatas.orderId}
                        customerId={customerId}
                        setRefresh={setRefresh}
                    />
                </SCUIGeneralDrawer>
            )}
            {returnDatas && (
                <SCUIGeneralDrawer
                    open={mpShippingDrawerOpen}
                    width={'400px'}
                    onClose={(event: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            onMPShippingClose();
                        }
                    }}
                >
                    <Typography variant="h6" style={{ textAlign: 'center', marginBottom: '1rem', marginTop: '1rem' }}>
                        {t('general.marketplaceReturnShipmentPreparation')}
                    </Typography>
                    <RefundPrepareSellerReturnShipment
                        atDrawer={true}
                        shippingListId={returnDatas?.productDetailModels[0]?.shippingListId}
                        customerId={customerId}
                        returnId={returnDatas.returnId}
                    />
                </SCUIGeneralDrawer>
            )}
            {selectedProduct && selectedProduct.length > 0 && (
                <SCUIReturnDetailModalApprove
                    disableAprroveProduct={disableAprroveProduct}
                    open={modalOpen}
                    onClose={onModalClose}
                    product={selectedProduct[0]}
                    returnData={returnDatas}
                    returnReason={returnReason}
                    returnRejectedReason={returnRejectedReason}
                    selectedQrCodes={selectedQrCodes}
                    setSelectedQrCodes={setSelectedQrCodes}
                    formattedCreateConfirm={formattedCreateConfirm}
                    scannedBarcodeForModal={scannedBarcodeForModal}
                />
            )}
            {returnDatas && (
                <Grid container>
                    <Grid
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIBreadCrumb
                            components={[
                                {
                                    title: t('dashboard.returnRequests'),
                                    link: '/returnList',
                                    transferState: props.location.state,
                                },
                                { title: t('general.requestDetails'), link: '/returnDetail' },
                            ]}
                        />
                    </Grid>
                    <Grid
                        container
                        sx={{
                            margin: '1rem',
                            background: darkModeStore?.isDarkMode ? '#111' : 'white',
                            padding: '1rem',
                            width: '100%',
                        }}
                    >
                        <Grid container width="100%">
                            {trackingCode && trackingCode.trim() !== '' && (
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <p
                                        style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            marginTop: '1.5rem',
                                        }}
                                    >
                                        {t('general.returnShippingTrackingCode')} :&nbsp;{trackingCode}
                                    </p>
                                </Grid>
                            )}
                            <Grid
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 6,
                                    xl: 6,
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: '1.5rem',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        marginTop: '1.5rem',
                                    }}
                                >
                                    {t('general.requestCode')} :&nbsp;{returnDatas.rmaCode}
                                </p>
                            </Grid>
                            <Grid
                                sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 6,
                                    xl: 6,
                                }}
                            >
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                    }}
                                >
                                    {checkStatusInList(returnDatas.boStatus) && (
                                        <Tooltip title={t('orderDetail.cargoTracking')}>
                                            <Chip
                                                icon={<LocalShippingIcon />}
                                                style={{
                                                    padding: '4px',
                                                    color: '#03a9f4',
                                                    textDecoration: 'underline',
                                                }}
                                                label={shippingCompanyName || t('orderDetail.cargoTracking')}
                                                color="default"
                                                onClick={handleLinkClick}
                                            />
                                        </Tooltip>
                                    )}
                                </Grid>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                    }}
                                >
                                    <Tooltip title={t('return.returnStatus')}>
                                        <Button onClick={handleOpenChangeStatusModal}>
                                            <div
                                                style={{
                                                    ...chipStyleBackground,
                                                    marginLeft: '2rem',
                                                    backgroundColor: enumReturnStatus[returnDatas.status]?.colorCode,
                                                    color: 'white',
                                                    padding: '0.5rem',
                                                }}
                                            >
                                                <p style={{ fontSize: '10px' }}>{returnDatas.boStatusDescription}</p>
                                            </div>
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                    }}
                                >
                                    <Tooltip title={t('return.returnStatusHistory')}>
                                        <div style={{ width: '30px' }}>
                                            <Button
                                                onClick={toggleDrawer(true)}
                                                style={{ minWidth: 'auto', padding: 0 }}
                                            >
                                                <AccessTimeIcon
                                                    style={{ marginRight: '8px', fontSize: '2rem', color: '#03a9f4' }}
                                                />
                                            </Button>
                                        </div>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Divider
                        sx={{
                            width: '100%',
                            borderWidth: '0.5px', // Kalınlık
                            borderColor: 'lightgray', // Rengi
                            marginTop: '0.5rem', // İstenirse üst boşluk
                            marginBottom: '0.5rem', // İstenirse alt boşluk
                        }}
                        orientation="horizontal" // Yatay çizgi
                    />
                    <Grid
                        container
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Grid
                            direction={'column'}
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 6,
                                xl: 6,
                            }}
                        >
                            <Grid
                                sx={{ margin: '1rem' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 6,
                                    xl: 6,
                                }}
                            >
                                {' '}
                                <label>
                                    <strong>{t('return.returnId')}&nbsp;:&nbsp;</strong>
                                </label>{' '}
                                {returnDatas.returnId}
                            </Grid>
                            {refundId && (
                                <Grid
                                    sx={{ margin: '1rem' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 6,
                                        xl: 6,
                                    }}
                                >
                                    <div className="sideBySideDiv">
                                        <p>
                                            <strong>{t('return.refundPaymentNo')} &nbsp;: &nbsp; </strong>
                                        </p>{' '}
                                        <p className="linktxt" onClick={() => refund()}>
                                            {refundId}{' '}
                                            {Helper.isStoreEmployeeForFrontend() && (
                                                <label> {t('general.clickForRefundRecord')}</label>
                                            )}{' '}
                                        </p>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                        <Grid
                            direction={'column'}
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 6,
                                xl: 6,
                            }}
                        >
                            <Grid
                                sx={{ margin: '1rem' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 6,
                                    xl: 6,
                                }}
                            >
                                <div className="sideBySideDiv">
                                    <p style={{ marginTop: '1rem' }}>
                                        <strong>{t('general.orderNo')}&nbsp;:&nbsp; </strong>
                                    </p>
                                    <p style={{ marginTop: '1rem' }} className="linktxt" onClick={() => orderDetail()}>
                                        {returnDatas.orderNumber}{' '}
                                        {Helper.isStoreEmployeeForFrontend() && t('general.clickForOrderDetail')}
                                    </p>
                                    <CopyToClipboardButton textToCopy={returnDatas.orderNumber} />
                                </div>
                            </Grid>
                            {customerId && !Helper.isStoreEmployeeForFrontend() && (
                                <Grid
                                    sx={{ margin: '1rem' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <div className="sideBySideDiv" style={{ alignItems: 'center', flexWrap: 'nowrap' }}>
                                        <p>
                                            <strong>{t('customerInformation.customerOrders')}&nbsp;:&nbsp; </strong>
                                        </p>
                                        <p
                                            className="linktxt"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                whiteSpace: 'nowrap',
                                                margin: 0,
                                            }}
                                            onClick={() =>
                                                window.open(
                                                    import.meta.env.VITE_APPURL! +
                                                        '/customerManagement?ActiveTab=OrderInformation&customerId=' +
                                                        customerId,
                                                    '_blank'
                                                )
                                            }
                                        >
                                            {customerId}{' '}
                                            {Helper.isStoreEmployeeForFrontend() && t('general.clickForCustomerOrders')}
                                            <CopyToClipboardButton
                                                textToCopy={String(customerId)}
                                                sx={{ flexShrink: 0 }}
                                            />
                                        </p>
                                    </div>
                                </Grid>
                            )}
                            {!Helper.isStoreEmployeeForFrontend() && (
                                <Grid
                                    sx={{ margin: '1rem' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 6,
                                        xl: 6,
                                    }}
                                >
                                    {' '}
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        {' '}
                                        <p style={{ fontWeight: 'bold' }}>SCR :</p>{' '}
                                        <p style={{ color: 'red', fontWeight: 'bold' }}>
                                            {' '}
                                            {isBlackListCustomer ? (source === null ? 'Backoffice' : source) : '-'}
                                        </p>
                                        <div>{isBlackListCustomer && <ReportGmailerrorredIcon color="warning" />}</div>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container sx={{ margin: '1rem' }}>
                        {/* tamamlandı statüsünde mesaj gelmeyecek */}
                        {returnDatas.returnPlatformTypeId === 6 && (
                            <Grid
                                sx={{ paddingBottom: '10px' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 6,
                                }}
                            >
                                <div className="sideBySideDiv">
                                    <ReportIcon style={{ color: 'red', margin: '3px 5px' }}></ReportIcon>
                                    <p style={{ color: 'red' }}>{t('return.exceptionReturn')}</p>
                                </div>
                            </Grid>
                        )}

                        {returnDatas.returnMessages &&
                            !(returnDatas.status === 3 && returnDatas.isAutoReturn) &&
                            (returnDatas.status !== 3 ||
                                (returnDatas.status === 3 &&
                                    (returnDatas.returnPlatformTypeId === 6 ||
                                        returnDatas.returnPlatformTypeId === 2))) && (
                                //İade süreci Çağrı Merkezi tarafından tamamlanmış olup, ürünler ASTR depoya aktarılmıştır mesajı gösterilmiyor istendi
                                <Grid
                                    container
                                    sx={{ paddingBottom: '10px' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <strong>{t('general.refundMessage')} :&nbsp; </strong>
                                    <div>{parse(DOMPurify.sanitize(returnMessage))}</div>
                                </Grid>
                            )}

                        {returnDatas.returnMessages && returnDatas.status === 3 && returnDatas.isAutoReturn && (
                            <Grid
                                sx={{ paddingBottom: '10px' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <div className="sideBySideDiv returnMessageRow">
                                    <label>
                                        <strong>{t('general.refundMessage')}&nbsp;:&nbsp;</strong>
                                    </label>
                                    <span className="returnMessageContent">
                                        {parse(
                                            DOMPurify.sanitize(
                                                returnMessage ? returnMessage : t('general.returnSuccessMessages')
                                            )
                                        )}
                                    </span>
                                </div>
                            </Grid>
                        )}
                        {/* geri ödeme bekliyor durumunda gelecek */}
                        {returnDatas.boStatus === 2 && (
                            <Grid
                                sx={{ paddingBottom: '10px' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <Typography variant="caption" display="block" gutterBottom color="red">
                                    <b>{t('general.returnErrorMessages')} </b>
                                </Typography>
                            </Grid>
                        )}

                        {/* iade tamamlandı ve herhangi bir ürün reddedildiyse gösteriyoruz */}
                        {returnRejectShipmentVisible &&
                            !(
                                returnDatas.boStatus === 0 ||
                                returnDatas.boStatus === 1 ||
                                returnDatas.boStatus === 2 ||
                                returnDatas.boStatus === 4
                            ) &&
                            rejectedShippingIDs &&
                            rejectedShippingIDs.map((rejectedShippingId: any, index: number) => (
                                <Grid
                                    key={index}
                                    sx={{ paddingBottom: '10px' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 6,
                                    }}
                                >
                                    <b
                                        className="linktxt"
                                        onClick={() => {
                                            onDrawerRejectedOpen();
                                            setSelectedsetRejectedShippingID(rejectedShippingId);
                                        }}
                                    >
                                        {rejectedShippingId} {t('return.returnRejectShipmentOperations')}
                                    </b>
                                </Grid>
                            ))}
                        {returnDatas &&
                            (returnDatas.boStatus === 10 ||
                                returnDatas.status === 10 ||
                                returnDatas.boStatus === 9 ||
                                returnDatas.status === 9 ||
                                returnDatas.boStatus === 11 ||
                                returnDatas.status === 3) &&
                            isMarketPlaceReturn && (
                                <Grid
                                    sx={{ paddingBottom: '10px' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 6,
                                    }}
                                >
                                    <b
                                        className="linktxt"
                                        onClick={() => {
                                            onMPShippingOpen();
                                        }}
                                    >
                                        {t('general.marketplaceReturnShipmentPreparation')}
                                    </b>
                                </Grid>
                            )}
                    </Grid>
                    {returnDatas.isCancelable && (
                        <Paper style={{ width: '100%', marginTop: '1rem' }}>
                            <Grid
                                container
                                sx={{ marginTop: '0.7rem' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <Grid
                                    container
                                    size={{
                                        sm: 12,
                                        md: 6,
                                        lg: 5,
                                        xl: 5,
                                    }}
                                >
                                    {returnDatas.isReturnable && returnDatas.isShowBarcodeSearch && (
                                        <Grid
                                            size={{
                                                sm: 12,
                                                md: 8,
                                                lg: 8,
                                                xl: 8,
                                            }}
                                        >
                                            <SCUITextFieldWithButton
                                                autoFocus={true}
                                                value={selectedProductBarcode}
                                                width={300}
                                                placeholder={t('general.barcodeSearch')}
                                                buttonText={t('general.search')}
                                                onChange={(event: any) => {
                                                    setSelectedProductBarcode(event.target.value);
                                                }}
                                                onClick={barcodeSearch}
                                                onKeyPress={(e: any) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        barcodeSearch();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid
                                    container
                                    size={{
                                        sm: 12,
                                        md: 7,
                                        lg: 7,
                                        xl: 7,
                                    }}
                                >
                                    <Grid
                                        size={{
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                gap: '1rem',
                                                marginTop: '5px',
                                                alignItems: 'center',
                                                flexWrap: 'nowrap',
                                                overflow: 'visible',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {returnDatas?.status !== 2 &&
                                                returnDatas.isCancelable &&
                                                returnDatas.isShowCancelButton && (
                                                    <SCUIButton
                                                        text={t('return.cancel')}
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'m'}
                                                        buttonType="button"
                                                        disabled={disabledCancelButton}
                                                        onClick={CancelReturn}
                                                    />
                                                )}
                                            {/* status = 2 geri ödeme bekliyor anlamına gelir. */}
                                            {((returnDatas.isResetable && showResetButtonFromRule) ||
                                                (returnDatas?.status !== 2 && returnDatas.isResetable)) && (
                                                <SCUIButton
                                                    text="Reset"
                                                    type="primary"
                                                    sizeType="fixed"
                                                    size="m"
                                                    buttonType="button"
                                                    disabled={disabledResetButton}
                                                    onClick={ResetReturn}
                                                />
                                            )}
                                            {returnDatas.isReturnable &&
                                                returnedProductItemProcesses.length > 0 &&
                                                visibleTaslakButton &&
                                                !Helper.isStoreEmployeeForFrontend() && (
                                                    <SCUIButton
                                                        text={
                                                            cachedRequestData
                                                                ? t('general.updateDraft')
                                                                : t('general.saveAsDraft')
                                                        }
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'m'}
                                                        buttonType="button"
                                                        onClick={
                                                            cachedRequestData
                                                                ? UpdateCompleteAndConfirmQueryRequestData
                                                                : AddCompleteAndConfirmQueryRequestData
                                                        }
                                                    />
                                                )}
                                            {visibleCreateAndConfirmButton && returnDatas.isReturnable && (
                                                <span ref={completeAndConfirmButtonRef}>
                                                    <SCUIButton
                                                        text={t('general.complete')}
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'m'}
                                                        buttonType="button"
                                                        onClick={CompleteAndConfirmReturn}
                                                        disabled={disabledCompleteAndConfirmButton}
                                                    />
                                                </span>
                                            )}
                                            {!Helper.getStoreCode() && (
                                                <Tooltip title={t('general.draftHistory')}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            marginRight: '1rem',
                                                            whiteSpace: 'nowrap',
                                                            minWidth: 'fit-content',
                                                            flexShrink: 0,
                                                        }}
                                                        onClick={draftHistory}
                                                    >
                                                        <AccessTimeIcon
                                                            style={{
                                                                fontSize: '1.5rem',
                                                                color: '#03a9f4',
                                                                marginRight: '0.5rem',
                                                            }}
                                                        />
                                                        <Typography
                                                            style={{ color: '#03a9f4', textDecoration: 'underline' }}
                                                        >
                                                            {t('general.draftHistory')}
                                                        </Typography>
                                                    </div>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid
                                sx={{ float: 'right' }}
                                size={{
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                {returnDatas.isReturnable &&
                                    returnedProductItemProcesses.length > 0 &&
                                    visibleTaslakButton &&
                                    !Helper.isStoreEmployeeForFrontend() &&
                                    draftPerson && (
                                        <p
                                            style={{
                                                color: !darkModeStore?.isDarkMode ? 'gray' : 'orange',
                                                fontStyle: 'italic',
                                            }}
                                        >
                                            {selectedLanguage === 'tr-TR'
                                                ? `${draftPerson} ${t('general.savedAsDraftBy')}`
                                                : `${t('general.savedAsDraftBy')} ${draftPerson}`}
                                        </p>
                                    )}
                            </Grid>
                            <Grid
                                sx={{ mt: 1 }}
                                size={{
                                    sm: 12,
                                    md: 6,
                                    lg: 4,
                                    xl: 12,
                                }}
                            >
                                {returnDatas.isReturnable &&
                                    !selectableProductForComplete &&
                                    returnDatas.isAllSelectable && (
                                        <p className="linktxt" onClick={() => setSelectableProductForComplete(true)}>
                                            {t('general.bulkOperation')}
                                        </p>
                                    )}
                                {returnDatas.isReturnable && selectableProductForComplete && (
                                    <p
                                        className="linktxt"
                                        onClick={() => {
                                            setSelectableProductForComplete(false);
                                            resetCompleteAndConfirmAll();
                                        }}
                                    >
                                        {t('general.closeBulkOperation')}
                                    </p>
                                )}
                            </Grid>
                            {productCountIsBigger && (
                                <Grid
                                    sx={{ paddingBottom: '10px' }}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <Typography variant="h6" display="block" gutterBottom color="red">
                                        <b>{t('general.cannotAddMoreThanQuantity')} </b>
                                    </Typography>
                                </Grid>
                            )}
                            {barcodeNotFound && (
                                <Grid container direction="row" sx={{ padding: '25px' }}>
                                    <Grid
                                        size={{
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <Typography variant="h6" display="block" gutterBottom color="red">
                                            <b>{t('general.productNotFound')} </b>
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        size={{
                                            sm: 12,
                                            md: 6,
                                            lg: 6,
                                            xl: 6,
                                        }}
                                    >
                                        <Link
                                            to={`/orders?Barcodes=${selectedProductBarcode}&orderStatusIds=4,8`}
                                            target="_blank"
                                        >
                                            <p className="linktxt">
                                                {' '}
                                                {`${selectedProductBarcode}  ${t('general.ordersWithBarcode')}`}
                                            </p>
                                        </Link>
                                    </Grid>
                                    <Grid
                                        size={{
                                            sm: 12,
                                            md: 6,
                                            lg: 6,
                                            xl: 6,
                                        }}
                                    >
                                        <Link
                                            to={`/CustomerManagement?ActiveTab=OrderInformation&customerId=${customerId}&Barcodes=${selectedProductBarcode}`}
                                            target="_blank"
                                        >
                                            <p className="linktxt">
                                                {' '}
                                                {`${t('general.customerOrders')} ${selectedProductBarcode} ${t(
                                                    'general.ordersWithBarcode'
                                                )}`}
                                            </p>
                                        </Link>
                                    </Grid>
                                </Grid>
                            )}
                            {selectableProductForComplete && returnDatas.isReturnable && (
                                <Grid
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(e) =>
                                                    e.target.checked
                                                        ? CompletAndConfirmAll()
                                                        : resetCompleteAndConfirmAll()
                                                }
                                            />
                                        }
                                        label="Tümünü seç"
                                    />
                                </Grid>
                            )}
                        </Paper>
                    )}
                    {returnDatasProducts && returnReason && returnRejectedReason && (
                        <SCUIReturnDetailProductTable
                            disableAprroveProduct={disableAprroveProduct}
                            isRejectedReturn={isRejectedReturn}
                            resetForSelectedProduct={resetForSelectedProduct}
                            returnDatasProducts={returnDatasProducts}
                            selectable={selectableProductForComplete}
                            returnData={returnDatas}
                            customerID={customerId}
                            returnReason={returnReason}
                            returnRejectedReason={returnRejectedReason}
                            formattedCreateConfirm={formattedCreateConfirm}
                            selectedQrCodes={selectedQrCodes}
                            setSelectedQrCodes={setSelectedQrCodes}
                        />
                    )}
                </Grid>
            )}
            {draftHistoryModalOpen && (
                <Dialog open={draftHistoryModalOpen} onClose={handleCloseDraftHistory} maxWidth="md" fullWidth>
                    <DialogContent>
                        <Grid container spacing={2} sx={{ padding: '16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <p
                                    style={{
                                        color: '#5b99f3',
                                        marginBottom: '1rem',
                                        marginTop: '1rem',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        paddingLeft: '16px',
                                    }}
                                >
                                    {t('general.draftHistory')}
                                </p>
                                <Button>
                                    <CloseIcon
                                        style={{ height: 'auto', width: '25px' }}
                                        onClick={handleCloseDraftHistory}
                                    />
                                </Button>
                            </div>
                            <Grid
                                size={{
                                    xs: 12,
                                }}
                            >
                                <Divider />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                }}
                            >
                                <div style={{ marginTop: '15px', width: '100%' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            borderBottom: '1px solid #ddd',
                                            padding: '8px 0',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        <div style={{ flex: 1, textAlign: 'left' }}>{t('orderDetail.date')}</div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>{t('orderDetail.user')}</div>
                                        <div style={{ flex: 1, textAlign: 'left' }}>{t('orderDetail.barcode')}</div>
                                    </div>

                                    {draftHistoryData?.length === 0 ? (
                                        <div style={{ padding: '15px 0', color: '#777', textAlign: 'center' }}>
                                            <Typography variant="h2">{t('general.draftHistoryNotFound')}</Typography>
                                        </div>
                                    ) : (
                                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            {draftHistoryData?.map(function (
                                                item: {
                                                    createTime: string;
                                                    userName: string;
                                                    barcodes: number[] | string;
                                                    userRef?: number;
                                                },
                                                index: number
                                            ) {
                                                let barcodesArray: string[] = [];
                                                if (Array.isArray(item.barcodes)) {
                                                    barcodesArray = item.barcodes.map((b) => b.toString());
                                                } else if (typeof item.barcodes === 'string') {
                                                    barcodesArray = item.barcodes.split(',').map((b) => b.trim());
                                                }
                                                const isExpanded = expandedBarcodesRows[index] === true;

                                                return (
                                                    <React.Fragment key={index}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                borderBottom: '1px solid #eee',
                                                                padding: '10px 0',
                                                            }}
                                                        >
                                                            <div style={{ flex: 1, textAlign: 'left' }}>
                                                                {new Date(item.createTime).toLocaleString('tr-TR')}
                                                            </div>
                                                            <div style={{ flex: 1, textAlign: 'left' }}>
                                                                {item.userName}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                    textAlign: 'left',
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                                onClick={() => toggleBarcodeRowExpansion(index)}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <span>
                                                                        {barcodesArray?.length}{' '}
                                                                        {t('orderDetail.barcode')}
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            marginLeft: '5px',
                                                                            color: '#0066cc',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {isExpanded ? '▼' : '▶'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {isExpanded && (
                                                            <div
                                                                style={{
                                                                    padding: '5px 15px',
                                                                    backgroundColor: '#f5f5f5',
                                                                    borderBottom: '1px solid #ddd',
                                                                    marginLeft: '33.3%',
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        maxHeight: '300px',
                                                                        overflowY: 'auto',
                                                                    }}
                                                                >
                                                                    {barcodesArray?.map(function (
                                                                        barcode: string,
                                                                        idx: number
                                                                    ) {
                                                                        return (
                                                                            <div
                                                                                key={idx}
                                                                                style={{
                                                                                    padding: '3px 6px',
                                                                                    marginBottom: '2px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '3px',
                                                                                    fontSize: '12px',
                                                                                }}
                                                                            >
                                                                                {barcode}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            )}
        </SCUIContent>
    );
};
